let url = $(location).attr('href').split('/').splice(0, 5).join('/');
let segments = url.split('/');
let lang = segments[3];
let two_segment = segments[4];
if ('' === lang) {
	lang = 'en';
}

let main_loader = `<ul class="loader_body">
						<li class="loader_center"></li>
						<li class="loader_item loader_item-1"></li>
						<li class="loader_item loader_item-2"></li>
						<li class="loader_item loader_item-3"></li>
						<li class="loader_item loader_item-4"></li>
						<li class="loader_item loader_item-5"></li>
						<li class="loader_item loader_item-6"></li>
						<li class="loader_item loader_item-7"></li>
						<li class="loader_item loader_item-8"></li>
					</ul>`;

window.addEventListener('load', function () {
	setTimeout(function () {
		const loader = document.getElementById('loader');
		const wrapper = document.querySelector('.wrapper');
		if (loader && wrapper) {
			loader.classList.add('loader_hidden');
			setTimeout(function () {
				loader.style.display = 'none';
				wrapper.style.display = 'block';
			}, 500);
		}
	}, 1000);
});

function addLoader(containerSelector, timeout, styles, callback) {
	if (styles && typeof styles === 'object') {
		$(containerSelector).css(styles);
	}
	$(containerSelector).html(main_loader);

	if (timeout && typeof timeout === 'number') {
		setTimeout(function () {
			// $(containerSelector).empty();
			if (typeof callback === 'function') {
				callback();
			}
		}, timeout);
	} else if (typeof callback === 'function') {
		callback();
	}
}

function send_notification(active, message) {
	addLoader('.custom__loader', 500, {}, function () {
		$.ajax({
			url: '/notifications/send', // путь к обработчику
			type: 'POST', // метод отправки,
			dataType: 'json',
			data: {
				active: active,
				message: message,
			},
			success: function (data) {
				if (data.status == 'ok') {
					$('.notifications__body').html(data.view);
				}
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});
}

function handleSelectOption(selectClass, callback) {
	$(selectClass)
		.find('.select__options')
		.on('click', '.select__option', function () {
			var $clicked = $(this);
			var value = $clicked.data('value');

			var $select = $(this).closest(selectClass).find('select');
			var option = $select.find('option[value="' + value + '"]')[0];

			if (typeof callback === 'function') {
				callback(option);
			}
		});
}

function AttachSelector() {
	//Select
	let selects = [];
	selects = Array.from(
		document
			.querySelector('.dashboard__filters_mob')
			.getElementsByTagName('select')
	).filter(
		select =>
			!select.classList.contains('select2-ajax-pickup') &&
			!select.classList.contains('select2-ajax-delivery')
	);
	selects = selects.concat(
		Array.from(
			document
				.querySelector('.dashboard__container .dashboard-filter')
				.getElementsByTagName('select')
		).filter(
			select =>
				!select.classList.contains('select2-ajax-pickup') &&
				!select.classList.contains('select2-ajax-delivery')
		)
	);
	if (selects.length > 0) {
		selects_init();
	}
	function selects_init() {
		for (let index = 0; index < selects.length; index++) {
			const select = selects[index];
			select_init(select);
		}
		//select_callback();
		document.addEventListener('click', function (e) {
			selects_close(e);
		});
		document.addEventListener('keydown', function (e) {
			if (e.code === 'Escape') {
				selects_close(e);
			}
		});
	}
}
function AttachSpoller() {
	//Spollers
	spollers = document.querySelectorAll('._spoller');
	spollersGo = true;
	if (spollers.length > 0) {
		for (let index = 0; index < spollers.length; index++) {
			const spoller = spollers[index];
			spoller.addEventListener('click', function (e) {
				if (e.target.closest('a')) {
					return false;
				} else if (spollersGo) {
					spollersGo = false;
					if (spoller.classList.contains('_mmd1') && window.innerWidth < 1272) {
						return false;
					}
					if (
						spoller.classList.contains('_spoller-992') &&
						window.innerWidth > 992
					) {
						return false;
					}
					if (
						spoller.classList.contains('_spoller-768') &&
						window.innerWidth > 768
					) {
						return false;
					}
					if (spoller.closest('._spollers').classList.contains('_one')) {
						let curent_spollers = spoller
							.closest('._spollers')
							.querySelectorAll('._spoller');
						for (let i = 0; i < curent_spollers.length; i++) {
							let el = curent_spollers[i];
							if (el != spoller) {
								el.classList.remove('_active');
								_slideUp(el.nextElementSibling);
							}
						}
					}
					spoller.classList.toggle('_active');
					_slideToggle(spoller.nextElementSibling);

					setTimeout(function () {
						spollersGo = true;
					}, 500);
				}
			});
		}
	}
}
function AttachPlaceholder(pickup_date) {
	//Placeholders
	inputs = document.querySelectorAll('input[data-value],textarea[data-value]');
	inputs_init(inputs);

	// Initial
	let selectedDates = [
		new Date(),
		// new Date(new Date().setDate(new Date().getDate() + 4)),
	];

	if (pickup_date) {
		const dateParts = pickup_date.split(' - ');
		if (dateParts.length === 2) {
			const startDate = parseDate(dateParts[0]);
			const endDate = parseDate(dateParts[1]);
			if (startDate && endDate) {
				selectedDates = [startDate, endDate];
			}
		} else if (dateParts.length === 1) {
			const singleDate = parseDate(dateParts[0]);
			if (singleDate) {
				selectedDates = [singleDate];
			}
		}
	}

	datepickerF = new AirDatepicker('#datepickerF', {
		disabledDates: true,
		minDate: new Date(),
		range: true, // Включение режима выбора диапазона
		toggleSelected: false,
		multipleDatesSeparator: ' - ',
		dateFormat: 'MMM dd, yyyy', // Формат даты (сокращенное название месяца и день)
		locale: customLocale,
		selectedDates: selectedDates,
		autoClose: true,
	});

	inputPickerTruck = new AirDatepicker('#inputPickerTruck', {
		disabledDates: true,
		minDate: new Date(),
		dateFormat: 'MMM dd, yyyy', // Формат даты (сокращенное название месяца и день)
		locale: customLocale,
		autoClose: true,
	});

	inputPickerBook = new AirDatepicker('#inputPickerBook', {
		disabledDates: true,
		minDate: new Date(),
		dateFormat: 'MMM dd, yyyy', // Формат даты (сокращенное название месяца и день)
		locale: customLocale,
		autoClose: true,
	});
}
function AttachPopup() {
	//=================
	//Popups
	let popup_link = document.querySelectorAll('._popup-link');
	let popups = document.querySelectorAll('.popup');
	for (let index = 0; index < popup_link.length; index++) {
		const el = popup_link[index];
		el.addEventListener('click', function (e) {
			if (unlock) {
				let item = el.getAttribute('href').replace('#', '');
				let video = el.getAttribute('data-video');
				popup_open(item, video);
			}
			e.preventDefault();
		});
	}
	for (let index = 0; index < popups.length; index++) {
		const popup = popups[index];
		popup.addEventListener('click', function (e) {
			if (!e.target.closest('.popup__body')) {
				popup_close(e.target.closest('.popup'));
			}
		});
	}
	let popup_close_icon = document.querySelectorAll(
		'.popup__close,._popup-close'
	);
	if (popup_close_icon) {
		for (let index = 0; index < popup_close_icon.length; index++) {
			const el = popup_close_icon[index];
			el.addEventListener('click', function () {
				popup_close(el.closest('.popup'));
			});
		}
	}
	document.addEventListener('keydown', function (e) {
		if (e.code === 'Escape') {
			popup_close();
		}
	});
}

function parseDate(dateString) {
	const months = [
		'Jan',
		'Feb',
		'Mar',
		'Apr',
		'May',
		'Jun',
		'Jul',
		'Aug',
		'Sep',
		'Oct',
		'Nov',
		'Dec',
	];

	const parts = dateString.split(' ');

	const monthStr = parts[0];
	const day = parseInt(parts[1], 10);
	const year = parseInt(parts[2], 10);

	const monthIndex = months.indexOf(monthStr);

	// If the month is invalid, return null
	if (monthIndex === -1 || isNaN(day) || isNaN(year)) {
		console.log('Invalid date:', dateString);
		return null;
	}

	// Create the date object
	const date = new Date(year, monthIndex, day);

	// Check if the created date is valid
	return isNaN(date.getTime()) ? null : date;
}

function AttachShowPass() {
	let viewPass = document.querySelectorAll('.showpass');
	for (let index = 0; index < viewPass.length; index++) {
		const element = viewPass[index];
		element.addEventListener('click', function (e) {
			if (element.classList.contains('_active')) {
				element.parentElement
					.querySelector('input')
					.setAttribute('type', 'password');
			} else {
				element.parentElement
					.querySelector('input')
					.setAttribute('type', 'text');
			}
			element.classList.toggle('_active');
		});
	}
}

$(document).ready(function () {
	//! Connections
	$(document).on('click', '.get__api', function (e) {
		e.preventDefault();
		const id = $(this).closest('.connection_container').data('id');

		addLoader('.custom__loader', 800, { height: '250px' }, function () {
			$.ajax({
				url: '/' + lang + '/connection/get', // путь к обработчику
				type: 'POST', // метод отправки,
				dataType: 'json',
				data: { id: id },
				success: function (data) {
					if (data.status == 'ok') {
						$('.connection_login').remove();
						$('.wrapper').append(data.view);
						AttachPopup();
						AttachShowPass();
					}
				},
				error: function (data) {
					console.log(data); // выводим ошибку в консоль
				},
			});
		});
	});
	$(document).on('click', '.connect__api', function (e) {
		e.preventDefault();

		let allData = {};
		let connection = $('form[name=connection]').serializeArray();
		$.each(connection, function (index, field) {
			allData[field.name] = field.value;
		});

		addLoader('.custom__loader', 800, { height: '250px' }, function () {
			$.ajax({
				url: '/' + lang + '/connection/add', // путь к обработчику
				type: 'POST', // метод отправки,
				dataType: 'json',
				data: allData,
				success: function (data) {
					if (data.status == 'ok') {
						$('.connection_login').replaceWith(data.view);
					} else {
						$('.connection_login').replaceWith(data.view);
						AttachPopup();
					}
				},
				error: function (data) {
					console.log(data); // выводим ошибку в консоль
				},
			});
		});
	});
	$(document).on('click', '.disconnect__api', function (e) {
		e.preventDefault();
		const container = $(this).closest('.connection_container');
		const id = container.data('id');
		const title = container.data('title');
		container.closest('.page').addClass('custom__loader');

		addLoader('.custom__loader', 800, { height: '250px' }, function () {
			$.ajax({
				url: '/' + lang + '/connection/remove', // путь к обработчику
				type: 'POST', // метод отправки,
				dataType: 'json',
				data: {
					id: id,
					title: title,
				},
				success: function (data) {
					if (data.status == 'ok') {
						location.reload();
					}
				},
				error: function (data) {
					console.log(data); // выводим ошибку в консоль
				},
			});
		});
	});

	//! Notifications
	$(document).on('click', '.clear__notifications', function (e) {
		e.preventDefault();
		const _self = $(this);

		$.ajax({
			url: '/notifications/clear', // путь к обработчику
			type: 'GET', // метод отправки,
			dataType: 'json',
			success: function (data) {
				if (data.status == 'ok') {
					$('.notifications__body').html(data.view);
				}
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});
	$(document).on('click', '.notification__item', function (e) {
		e.preventDefault();
		const _self = $(this);
		let id = _self.data('id');
		let url = _self.data('url');

		$.ajax({
			url: '/notifications/clicked', // путь к обработчику
			type: 'POST', // метод отправки,
			dataType: 'json',
			data: { id: id },
			success: function (data) {
				if (data.status == 'ok') {
					window.location.href = url;
				}
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});

	//! Favorites
	$(document).on('click', '.add_to_favorite', function (event) {
		event.preventDefault();
		const _self = $(this);
		const id = _self.data('id');

		$.ajax({
			url: '/' + lang + '/ajax/add_to_favorite', // путь к обработчику
			type: 'POST', // метод отправки,
			dataType: 'json',
			data: { id: id },
			success: function (data) {
				$('[data-id="' + id + '"]').each(function () {
					if (data.action === 'add') {
						$(this).addClass('_liked');
						$(this).addClass('_active');
					} else {
						$(this).removeClass('_liked');
						$(this).removeClass('_active');
						if ($(this).hasClass('delete_favorite')) {
							window.location.reload();
						}
					}
				});
				$('.favorite_count').text(data.count);
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});

	//! Share
	$(document).on('click', '.share__page', function (event) {
		event.preventDefault();
		const url = $(this).data('url');

		function copyToClipboard(url) {
			if (navigator.clipboard) {
				navigator.clipboard
					.writeText(url)
					.then(() => {
						alert('Link copied to clipboard!');
					})
					.catch(err => {
						console.log('Error copying text: ', err);
					});
			} else {
				console.log(
					'Clipboard API is not supported in this browser. Please copy the link manually: ' +
						url
				);
			}
		}

		const isMac = /Macintosh|MacIntel|MacPPC|Mac68K/.test(navigator.platform);

		if (isMac) {
			console.log(
				'macOS detected. Skipping share menu and copying link directly.'
			);
			copyToClipboard(url);
		} else {
			if (navigator.share) {
				navigator
					.share({
						title: document.title,
						url: url,
					})
					.then(() => {
						console.log('Successfully shared!');
					})
					.catch(error => {
						console.log('Error sharing:', error);
						copyToClipboard(url);
					});
			} else {
				console.log(
					'Sharing is not supported in this browser. Copying the link manually...'
				);
				copyToClipboard(url);
			}
		}
	});

	//! Dashboard
	if ($('.dashboard__container').length) {
		$(document).on('click', '.create_filters_search', function (event) {
			event.preventDefault();
			const _self = $(this);
			reload_flt('filters', 'create');
		});
		$(document).on('click', '.remove_filters_search', function (event) {
			event.preventDefault();
			const _self = $(this);
			const filter_search = _self.closest('.filter_search_container');
			const id = filter_search.data('id');
			reload_flt('filters', 'remove', id);
		});
		$(document).on('click', '.change_filters_search', function (event) {
			event.preventDefault();
			const _self = $(this);
			const filter_search = _self.closest('.filter_search_container');
			const id = filter_search.data('id');

			reload_flt('filters', 'change', id);
		});
		handleSelectOption('.sort__loads', function (option) {
			event.preventDefault();
			let value = option.value;

			reload_flt('sort', 'set', value);
		});

		$(document).on('click', '.head-dashboard__column', function (event) {
			event.preventDefault();
			const form = $('#sort_column');
			const sort = form.find('input[name="sort"]').val();
			const order = form.find('input[name="order"]').val();

			reload_flt('sort', 'column', `${sort}|${order}`);
		});

		let page = 2;
		$('.dashboard__list .dashboard__body').on('scroll', function () {
			let scrollTop = $(this).scrollTop();
			let innerHeight = $(this).innerHeight();
			let scrollHeight = $(this)[0].scrollHeight;

			if (scrollTop + innerHeight >= scrollHeight - 1) {
				$.ajax({
					url: '/' + lang + '/dashboard/load_more?page=' + page, // путь к обработчику
					type: 'GET', // метод отправки,
					dataType: 'json',
					success: function (data) {
						if (data.status == 'ok') {
							$('.dashboard__list .dashboard__body').append(data.view);
							page++;
						}
					},
					error: function (data) {
						console.log(data); // выводим ошибку в консоль
					},
				});
			}
		});

		function reload_flt(type, action, value = null) {
			let ajax__list = $('.dashboard__list .dashboard__body');
			let ajax__filters = $('.dashboard__filters');
			let ajax__filters_mob = $('.dashboard__filters_mob');
			let ajax__filters_search = $('.dashboard__filters_search');
			let ajax__filters_count = $('.dashboard__filters_count');
			ajax__list.css({
				opacity: 0.6,
			});

			let allData = {};
			let filters = $('form[name=filters]').serializeArray();
			$.each(filters, function (index, field) {
				if (field.name.startsWith('filters[trailer_types]')) {
					let match = field.name.match(/filters\[trailer_types\]\[([^\]]+)\]/);
					if (match) {
						allData['filters[trailer_types]'] =
							allData['filters[trailer_types]'] || [];
						allData['filters[trailer_types]'].push(match[1]);
					}
				} else if (field.name.startsWith('filters[pickup_date]')) {
					allData[field.name] = field.value;
				} else {
					allData[field.name] = field.value;
				}
			});

			let data = null;
			switch (type) {
				case 'filters':
					switch (action) {
						case 'create':
							data = allData;
							break;
						case 'remove':
							data = { id: value };
							break;
						case 'change':
							data = { id: value };
							break;
						default:
							break;
					}
					break;
				case 'sort':
					switch (action) {
						case 'set':
							data = { sort: value };
							break;
						case 'column':
							data = { sort: value.split('|')[0], order: value.split('|')[1] };
							break;
						default:
							break;
					}
					break;
				default:
					break;
			}

			let url =
				'/' +
				lang +
				'/dashboard/filters_search?type=' +
				type +
				'&action=' +
				action;
			$.ajax({
				url: url, // путь к обработчику
				type: 'POST', // метод отправки,
				dataType: 'json',
				data: data,
				success: function (data) {
					if (data.status == 'ok') {
						// window.location.reload();
						ajax__list.html(data.view);
						ajax__filters.replaceWith(data.filters);
						ajax__filters_mob.replaceWith(data.filters_mob);
						ajax__filters_search.replaceWith(data.filters_search);
						ajax__filters_count.replaceWith(data.filters_count);
						ajax__list.css({
							opacity: 1,
						});

						AttachSelector();
						AttachSpoller();
						AttachPlaceholder(data.pickup_date);
						AttachPopup();
					}
				},
				error: function (data) {
					console.log(data); // выводим ошибку в консоль
				},
			});
		}

		const pickup_date = document.querySelector(
			"input[name='filters[pickup_date]']"
		).value;
		if (pickup_date) {
			const dateParts = pickup_date.split(' - ');
			let selectedDates = [];
			if (dateParts.length === 2) {
				const startDate = parseDate(dateParts[0]);
				const endDate = parseDate(dateParts[1]);
				if (startDate && endDate) {
					selectedDates = [startDate, endDate];
				}
			} else if (dateParts.length === 1) {
				const singleDate = parseDate(dateParts[0]);
				if (singleDate) {
					selectedDates = [singleDate, singleDate];
				}
			}
			if (selectedDates.length > 0) {
				datepickerF.update({
					selectedDates: selectedDates,
					autoClose: true,
				});
				datepickerP.update({
					selectedDates: selectedDates,
					autoClose: true,
				});
			}
		} else {
			datepickerF.update({
				selectedDates: [
					new Date(),
					// new Date(new Date().setDate(new Date().getDate() + 4)),
				],
			});
			datepickerP.update({
				selectedDates: [
					new Date(),
					// new Date(new Date().setDate(new Date().getDate() + 4)),
				],
			});
		}
	}

	//! Loads
	localStorage.removeItem('open_loads');
	$(document).on('click', '.load__box', function (event) {
		const load_id = $(this).data('id');

		// Get load
		$.ajax({
			url: '/' + lang + '/ajax/update_mob_load', // путь к обработчику
			type: 'POST', // метод отправки,
			dataType: 'json',
			data: {
				lang: lang,
				load_id: load_id,
			},
			success: function (data) {
				if (data.status == 'ok') {
					$('.mob_load').replaceWith(data.view);
				}
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	});
	$(document).on('click', '.load__spoller', function (event) {
		const load_id = $(this).closest('.load__box').data('id');
		const is_open = $(this).hasClass('_active');

		// Save the state to localStorage
		let open_loads = JSON.parse(localStorage.getItem('open_loads')) || [];
		if (!is_open) {
			open_loads = open_loads.filter(id => id !== load_id);
		} else {
			if (!open_loads.includes(load_id)) {
				open_loads.push(load_id);
			}
		}
		localStorage.setItem('open_loads', JSON.stringify(open_loads));
	});
});